<template>
  <div>
    <modal-my-incident-update
      :data="this.data_row"
      :stateArray="this.stateArray"
    />
    <div class="flex flex-wrap">
      <div class="w-full xl:w-4/12 py-4 mb-4 xl:mb-0 ">
        <card-chart-stats
          statSubtitle="MY PERSONAL INCIDENTS"
          :statTitle="this.dataMyPersonalIncidents.length"
          statArrow="up"
          statPercent="3.48"
          statPercentColor="text-green-500"
          statDescripiron="Shows the count of user personal incidents"
          statIconName="fas fa-male"
          statIconColor="bg-yellow-500"
        />
      </div>
      <div class="w-full xl:w-4/12 py-4 mb-4 xl:mb-0 px-4">
        <card-chart-stats
          statSubtitle="MY TEAMS INCIDENTS"
          :statTitle="this.dataMyTeamsIncidents.length"
          statArrow="up"
          statPercent="3.48"
          statPercentColor="text-green-500"
          statDescripiron="Shows the count of user teams incidents"
          statIconName="fas fa-percentage"
          statIconColor="bg-red-400"
        />
      </div>
      <div class="w-full xl:w-4/12 py-4 mb-4 xl:mb-0 ">
        <card-chart-stats
          statSubtitle="TOTAL INCIDENTS"
          :statTitle="this.dataMyTeamsIncidents.length + this.dataMyPersonalIncidents.length"
          statArrow="up"
          statPercent="3.48"
          statPercentColor="text-green-500"
          statDescripiron="Shows the total count of my incidents"
          statIconName="fas fa-people-arrows"
          statIconColor="bg-purple-500"
        />
      </div>
    </div>
    <div
      class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded"
    >
      <div class="rounded-t mb-0 px-4 py-3 bg-transparent">
        <div class="flex flex-wrap items-center">
          <div class="relative w-full max-w-full flex-grow flex-1">
            <h6 class="uppercase text-gray-500 mb-1 text-xs font-semibold">
              Overview
            </h6>
            <h2 class="text-black text-xl font-semibold">
              My Incidents - Data Table
            </h2>
          </div>
        </div>
      </div>
      <div class="p-4 flex-auto">
        <div class="relative">
          <vue-good-table
            :columns="columns"
            :lineNumbers="true"
            :rows="data_incident_table"
            @on-row-click="onRowClick"
            :search-options="{
              enabled: true,
              placeholder: 'Search Incident',
            }"
            :pagination-options="{
              enabled: true,
            }"
          >
            <div slot="emptystate" class="text-center">
              No incidents available.
            </div>
            <div slot="table-actions">
              <download-csv
                class="bg-blue-600 text-white active:bg-pink-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 mb-1"
                :data="data_incident_table"
                type="button"
                name="data_incident_table.csv"
              >
                <i class="fas fa-download"></i>
                Download CSV
              </download-csv>
            </div>
          </vue-good-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* 
  Class: CardMyIncidentsTable
  Description: This class representing a table with loaded my incidents.
*/

/* Imports */
import ModalMyIncidentUpdate from "@/components/Modals/Incidents/ModalMyIncidentUpdate.vue";
import CardChartStats from "@/components/Cards/Charts/CardChartStats.vue";
/* /Imports/ */

export default {
  /* 
    Define data with custom my incidents state values.
  */
  data() {
    return {
      dataMyPersonalIncidents: null,
      dataMyTeamsIncidents: null,
      dataAllIncidents: null,
      data_incident_table: [],
      data_row: null,
      stateArray: [
        { value: "New", label: "New" },
        { value: "In Progress", label: "In Progress" },
        { value: "On Hold", label: "On Hold" },
        { value: "Resolved", label: "Resolved" },
        { value: "Closed", label: "Closed" },
        { value: "Canceled", label: "Canceled" },
        { value: "Awaiting User Info", label: "Awaiting User Info" },
      ],
      columns: [
        {
          label: "Number",
          field: "number",
          filterable: true,
        },
        {
          label: "Category Name",
          field: "category_name",
          filterable: true,
        },
        {
          label: "Short Description",
          field: "short_description",
          filterable: true,
        },
        {
          label: "Description",
          field: "description",
          filterable: true,
        },
        {
          label: "Caller",
          field: "caller",
          filterable: true,
        },
        {
          label: "Executor",
          field: "executor",
          filterable: true,
        },
        {
          label: "State",
          field: "state",
          filterable: true,
        },
        {
          label: "Impact",
          field: "impact",
          filterable: true,
        },
        {
          label: "Urgency",
          field: "urgency",
          filterable: true,
        },
        {
          label: "Priority",
          field: "priority",
          filterable: true,
        },
        {
          label: "Created",
          field: "created_at",
          filterable: true,
        },
        {
          label: "Updated",
          field: "updated_at",
          filterable: true,
        },
        {
          label: "Type",
          field: "model_type",
          filterable: true,
        },
      ],
    };
  },

  /* Define different components for reusability. */
  components: {
    ModalMyIncidentUpdate,
    CardChartStats
  },

  /* Define methods for separate different logic. */
  methods: {
    /* Show modal for single incident. */
    onRowClick(params) {
      this.data_row = params.row;
      this.$modal.show("my-incident-update");
    },

    /* We got all user incidents and save them to state. */
    getMyPersonalIncidents() {
      this.$loading(true);

      this.$store
        .dispatch("incidentTable/getMyPersonalIncidents", this.currentUser.token)
        .then(() => {
          this.dataMyPersonalIncidents = this.$store.state.incidentTable.myPersonalIncidents;

          /* loop the dataMyPersonalIncidents array and create the table with the filtered data */
          for (var i = 0; i < this.dataMyPersonalIncidents.length; i++) {
            this.data_incident_table.push({
              id: this.dataMyPersonalIncidents[i].id,
              number: "INC" + this.dataMyPersonalIncidents[i].number,
              category_name: this.dataMyPersonalIncidents[i].category_id[0].name,
              short_description: this.dataMyPersonalIncidents[i].short_description,
              description: this.dataMyPersonalIncidents[i].description,
              caller:
                this.dataMyPersonalIncidents[i].caller[0].first_name +
                " " +
                this.dataMyPersonalIncidents[i].caller[0].last_name,
              executor:
                this.dataMyPersonalIncidents[i].executor[0].first_name +
                " " +
                this.dataMyPersonalIncidents[i].executor[0].last_name,
              state: this.dataMyPersonalIncidents[i].state,
              impact: this.dataMyPersonalIncidents[i].impact,
              urgency: this.dataMyPersonalIncidents[i].urgency,
              priority: this.dataMyPersonalIncidents[i].priority,
              created_at: this.dataMyPersonalIncidents[i].created_at,
              updated_at: this.dataMyPersonalIncidents[i].updated_at,
              token_caller: this.dataMyPersonalIncidents[i].caller[0].token,
              token_executor: this.dataMyPersonalIncidents[i].executor[0].token,
              model_type: this.dataMyPersonalIncidents[i].model_type
            });
          }

          this.$loading(false);
        });
    },

  /* We got all user incidents and save them to state. */
    getMyTeamsIncidents() {
      this.$store
        .dispatch("incidentTable/getMyTeamsIncidents", this.currentUser.token)
        .then(() => {
          this.dataMyTeamsIncidents = this.$store.state.incidentTable.myTeamsIncidents;

          /* loop the dataMyTeamsIncidents array and create the table with the filtered data */
          for (var i = 0; i < this.dataMyTeamsIncidents.length; i++) {
            this.data_incident_table.push({
              id: this.dataMyTeamsIncidents[i].id,
              number: "INC" + this.dataMyTeamsIncidents[i].number,
              category_name: this.dataMyTeamsIncidents[i].category_id[0].name,
              short_description: this.dataMyTeamsIncidents[i].short_description,
              description: this.dataMyTeamsIncidents[i].description,
              caller:
                this.dataMyTeamsIncidents[i].caller[0].first_name +
                " " +
                this.dataMyTeamsIncidents[i].caller[0].last_name,
              executor:
                this.dataMyTeamsIncidents[i].executor[0].first_name +
                " " +
                this.dataMyTeamsIncidents[i].executor[0].last_name,
              state: this.dataMyTeamsIncidents[i].state,
              impact: this.dataMyTeamsIncidents[i].impact,
              urgency: this.dataMyTeamsIncidents[i].urgency,
              priority: this.dataMyTeamsIncidents[i].priority,
              created_at: this.dataMyTeamsIncidents[i].created_at,
              updated_at: this.dataMyTeamsIncidents[i].updated_at,
              token_caller: this.dataMyTeamsIncidents[i].caller[0].token,
              token_executor: this.dataMyTeamsIncidents[i].executor[0].token,
              model_type: this.dataMyTeamsIncidents[i].model_type
            });
          }
        });
    },

    /* We got all incidents and save them to state. */
    getAllIncident() {
      this.$store.dispatch("incidentTable/getAllIncidents").then(() => {
        this.dataAllIncidents = this.$store.state.incidentTable.incidentData;
      });
    },
  },

  /* 
    Define computed properties to obtain different getters and setters and save them into the instance. 
  */
  computed: {
    /* 
      Obtain current user object from the store. 
    */
    currentUser() {
      return this.$store.state.auth.user;
    },
  },

  /* 
    Load all user incidents after the instance. 
  */
  mounted() {
    this.getAllIncident();
    this.getMyPersonalIncidents();
    this.getMyTeamsIncidents();
  },
};
</script>
